import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from './index';
export const GLOBAL = 'global';

interface GlobalState {
  value: number;
  status: 'idle' | 'loading' | 'failed';
  fetchDataList: Array<any>;
  isLogin: Boolean;
  userInfo: Object;
}

const initialState: GlobalState = {
  value: 0,
  status: 'idle',
  fetchDataList: [],
  isLogin: false,
  userInfo: {},
};

interface userInfoState {
  userName: String;
}

// A mock function to mimic making an async request for data
function fetchCount(amount = 1) {
  return new Promise<{ data: number }>((resolve) => setTimeout(() => resolve({ data: amount }), 1000));
}

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(`${GLOBAL}/fetchCount`, async (amount: number) => {
  const response = await fetchCount(amount);
  // The value we return becomes the `fulfilled` action payload
  return response.data;
});

// 创建一个slice
export const globalSlice = createSlice({
  // namespace
  name: GLOBAL,
  // 初始化的state
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      // Use the PayloadAction type to declare the contents of `action.payload`
      state.value += action.payload;
    },
    changeIsLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
    changeUserInfo: (state, action: PayloadAction<userInfoState>) => {
      state.userInfo = action.payload;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(incrementAsync.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(incrementAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value += action.payload;
      });
  },
});

// 导出同步的action
export const { increment, decrement, incrementByAmount, changeIsLogin, changeUserInfo } = globalSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCount = (state: RootState) => state[GLOBAL].value;
export const selectStatus = (state: RootState) => state[GLOBAL].status;
export const selectFetchData = (state: RootState) => state[GLOBAL].fetchDataList;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd =
  (amount: number): AppThunk =>
  (dispatch, getState) => {
    const currentValue = selectCount(getState());
    if (currentValue % 2 === 1) {
      dispatch(incrementByAmount(amount));
    }
  };

export default globalSlice.reducer;
